import React from 'react';
import { Helmet } from 'react-helmet';
import { MdDelete } from 'react-icons/md';

// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';

// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
// @ts-ignore
import PageTitleAndFilters from 'components/PageTitleAndFilters';
import PageTitleAndFiltersPusher from 'components/PageTitleAndFiltersPusher';
import RoleButton from 'components/RoleButton';
import SaveMessage from 'components/SaveMessage';
import SingleActiveTableRowGate from 'components/SingleActiveTableRowGate';
import ButtonIconWrapper from 'components/ButtonIconWrapper';

import { ADMIN } from 'components/RoleGate/constants';
import {
    CREATE_MODAL_QUERY_STRING_PARAM,
    DELETE_MODAL_QUERY_STRING_PARAM
} from 'components/VirtualizedTable/constants';

import ProductsVirtualizedTable from './components/ProductsVirtualizedTable';

// Environment
const { REACT_APP_PROJECT_NAME } = process.env;

export class Products extends React.PureComponent<{}> {
    render(): React.ReactElement {
        return (
            <ErrorBoundary
                namespace="Products"
                FallbackComponent={<ErrorBoundaryAlert />}
            >
                <Helmet>
                    <title>Products - {REACT_APP_PROJECT_NAME}</title>
                </Helmet>
                <PageTitleAndFilters
                    title="Products"
                    FirstActionButton={
                        <SingleActiveTableRowGate>
                            <RoleButton
                                requiredRoles={[ADMIN]}
                                params={{
                                    [DELETE_MODAL_QUERY_STRING_PARAM]: true
                                }}
                                buttonProps={{
                                    icon: true,
                                    color: 'black',
                                    basic: true,
                                    style: {
                                        marginRight: 0,
                                        marginLeft: 8
                                    }
                                }}
                            >
                                <ButtonIconWrapper>
                                    <MdDelete
                                        style={{
                                            fontSize: 20
                                        }}
                                    />
                                </ButtonIconWrapper>
                                Delete
                            </RoleButton>
                        </SingleActiveTableRowGate>
                    }
                    SecondActionButton={
                        <RoleButton
                            requiredRoles={[ADMIN]}
                            params={{
                                [CREATE_MODAL_QUERY_STRING_PARAM]: true
                            }}
                            buttonProps={{
                                secondary: true,
                                style: {
                                    marginRight: 0,
                                    marginLeft: 8
                                }
                            }}
                        >
                            Create New
                        </RoleButton>
                    }
                    searchInputPlaceholder="Search"
                    hideFilters
                    MessageComponent={
                        <SaveMessage
                            namespace={[
                                'PRODUCT_CREATE',
                                'PRODUCT_UPDATE',
                                'PRODUCT_DELETE'
                            ]}
                        />
                    }
                />
                <PageTitleAndFiltersPusher>
                    <ProductsVirtualizedTable tableId="products" />
                </PageTitleAndFiltersPusher>
            </ErrorBoundary>
        );
    }
}

export default Products;
